import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-d75c1e7a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "d-flex justify-content-center vh-100 bg-light",
    style: { "margin-top": "20px" }
};
const _hoisted_2 = { class: "container col-lg-8 col-md-10 col-sm-12" };
const _hoisted_3 = {
    key: 0,
    class: "card shadow-lg border-0 rounded-4 mb-5"
};
const _hoisted_4 = { class: "row g-0" };
const _hoisted_5 = { class: "col-md-6" };
const _hoisted_6 = {
    class: "mb-4 d-flex align-items-center justify-content-center",
    style: { "height": "400px" }
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "spinner-border text-primary",
    role: "status"
}, [
    /*#__PURE__*/ _createElementVNode("span", { class: "visually-hidden" }, "Cargando...")
], -1 /* HOISTED */));
const _hoisted_8 = { class: "image-container" };
const _hoisted_9 = ["src"];
const _hoisted_10 = {
    key: 0,
    class: "d-flex flex-wrap"
};
const _hoisted_11 = ["src", "alt", "onClick"];
const _hoisted_12 = {
    key: 1,
    class: "modal fade show d-block",
    tabindex: "-1"
};
const _hoisted_13 = { class: "modal-dialog modal-dialog-centered modal-lg" };
const _hoisted_14 = { class: "modal-content" };
const _hoisted_15 = { class: "modal-header" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h5", { class: "modal-title" }, "Vista Ampliada", -1 /* HOISTED */));
const _hoisted_17 = { class: "modal-body d-flex justify-content-center align-items-center" };
const _hoisted_18 = ["src"];
const _hoisted_19 = { class: "col-md-6 p-4" };
const _hoisted_20 = {
    key: 0,
    class: "h4 text-dark mb-4 fw-bold"
};
const _hoisted_21 = { class: "mb-4" };
const _hoisted_22 = { class: "list-unstyled" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Detalles:", -1 /* HOISTED */));
const _hoisted_24 = { class: "list-unstyled" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Modelo Proveedor:", -1 /* HOISTED */));
const _hoisted_26 = {
    key: 1,
    class: "mb-4"
};
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h4", { class: "h6 text-dark mb-2 fw-bold" }, "Especificaciones:", -1 /* HOISTED */));
const _hoisted_28 = { class: "list-unstyled" };
const _hoisted_29 = { key: 0 };
const _hoisted_30 = { key: 4 };
const _hoisted_31 = { class: "quantity-control d-flex align-items-center mb-4" };
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-minus" }, null, -1 /* HOISTED */));
const _hoisted_33 = [
    _hoisted_32
];
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-plus" }, null, -1 /* HOISTED */));
const _hoisted_35 = [
    _hoisted_34
];
const _hoisted_36 = { class: "d-grid gap-2 mb-4" };
const _hoisted_37 = ["disabled"];
const _hoisted_38 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2",
    role: "status",
    "aria-hidden": "true"
};
const _hoisted_39 = {
    key: 1,
    class: "lni lni-cart me-2"
};
const _hoisted_40 = {
    key: 2,
    class: "mt-3 text-center text-success"
};
const _hoisted_41 = {
    class: "mt-3 d-flex justify-content-center align-items-center gap-2 flex-wrap text-muted",
    style: { "font-size": "0.9rem" }
};
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", {
    class: "lni lni-warning me-1",
    style: { "font-size": "0.9rem" }
}, null, -1 /* HOISTED */));
const _hoisted_43 = {
    key: 1,
    class: "text-center py-5"
};
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "spinner-border text-primary",
    role: "status"
}, [
    /*#__PURE__*/ _createElementVNode("span", { class: "visually-hidden" }, "Cargando...")
], -1 /* HOISTED */));
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-muted mt-2" }, "Buscando productos similares...", -1 /* HOISTED */));
const _hoisted_46 = [
    _hoisted_44,
    _hoisted_45
];
const _hoisted_47 = { class: "productos-similares" };
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "h4 text-dark fw-bold mb-3" }, "Productos Similares", -1 /* HOISTED */));
const _hoisted_49 = { class: "row five-cols" };
const _hoisted_50 = ["onClick"];
const _hoisted_51 = { class: "product-image" };
const _hoisted_52 = {
    key: 0,
    class: "cart-button added",
    disabled: "",
    title: "Agregado al carrito"
};
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "icon-wrapper" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-cart" }),
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-checkmark-circle check-icon" })
], -1 /* HOISTED */));
const _hoisted_54 = [
    _hoisted_53
];
const _hoisted_55 = ["onClick", "disabled"];
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-cart" }, null, -1 /* HOISTED */));
const _hoisted_57 = [
    _hoisted_56
];
const _hoisted_58 = ["src"];
const _hoisted_59 = {
    key: 0,
    class: "product-added-overlay"
};
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "overlay-content" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-checkmark" }),
    /*#__PURE__*/ _createElementVNode("span", null, "Producto agregado")
], -1 /* HOISTED */));
const _hoisted_61 = [
    _hoisted_60
];
const _hoisted_62 = { class: "button" };
const _hoisted_63 = { key: 0 };
const _hoisted_64 = { class: "product-info" };
const _hoisted_65 = { class: "title" };
const _hoisted_66 = ["onClick"];
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", {
    class: "card-text text-secondary small mb-2",
    style: { "font-size": "1.1em" }
}, [
    /*#__PURE__*/ _createCommentVNode(" {{ producto.marca.nombre }} - {{ producto.modelo.nombre }} ")
], -1 /* HOISTED */));
const _hoisted_68 = {
    key: 3,
    class: "text-center py-4"
};
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h5", { class: "text-muted" }, "No hay productos similares disponibles por ahora.", -1 /* HOISTED */));
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "small" }, "Intenta buscar otra categoría o vuelve más tarde. 👀", -1 /* HOISTED */));
const _hoisted_71 = [
    _hoisted_69,
    _hoisted_70
];
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-cart" }, null, -1 /* HOISTED */));
const _hoisted_73 = [
    _hoisted_72
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Search = _resolveComponent("Search");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createCommentVNode(" Detalles del Producto "),
                (_ctx.product)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createCommentVNode(" Imagen principal (Portada) o Spinner mientras carga "),
                                _createElementVNode("div", _hoisted_6, [
                                    (_ctx.loading)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createCommentVNode(" Spinner de carga "),
                                            _hoisted_7
                                        ], 64 /* STABLE_FRAGMENT */))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createCommentVNode(" CONTENEDOR FIJO CON ASPECT-RATIO Y BOTÓN ENCIMA "),
                                            _createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("img", {
                                                    src: _ctx.selectedImage || 'https://via.placeholder.com/500x500',
                                                    alt: "Imagen principal del producto",
                                                    class: "main-image"
                                                }, null, 8 /* PROPS */, _hoisted_9),
                                                _createCommentVNode(" Botón de ampliar imagen "),
                                                _createElementVNode("button", {
                                                    class: "btn btn-light btn-ampliar",
                                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.ampliarImagenMiniatura(_ctx.selectedImage)))
                                                }, [
                                                    _createVNode(_component_Search, { size: 24 })
                                                ])
                                            ])
                                        ], 64 /* STABLE_FRAGMENT */))
                                ]),
                                _createCommentVNode(" Galería de miniaturas de imágenes "),
                                (!_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.imagenes, (image, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: index,
                                                class: "mb-3",
                                                style: { "width": "100px", "height": "100px", "margin-right": "10px" }
                                            }, [
                                                _createElementVNode("img", {
                                                    src: _ctx.getImagenPortada(image) ||
                                                        'https://via.placeholder.com/500x500',
                                                    alt: 'Imagen ' + (Number(index) + 1),
                                                    class: _normalizeClass(["img-fluid rounded", {
                                                            'border border-primary p-1 border-3': _ctx.selectedImage === _ctx.getImagenPortada(image),
                                                        }]),
                                                    onClick: ($event) => (_ctx.changeMainImage(image)),
                                                    style: { "cursor": "pointer", "object-fit": "cover", "width": "100%", "height": "100%", "margin-left": "20px" }
                                                }, null, 10 /* CLASS, PROPS */, _hoisted_11)
                                            ]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createCommentVNode(" Modal de Imagen con Zoom Interactivo "),
                                (_ctx.isModalMiniaturaOpen)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                            _createCommentVNode(" Hacemos el modal un poco más grande "),
                                            _createElementVNode("div", _hoisted_14, [
                                                _createElementVNode("div", _hoisted_15, [
                                                    _hoisted_16,
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "btn-close",
                                                        onClick: _cache[1] || (_cache[1] =
                                                            //@ts-ignore
                                                            (...args) => (_ctx.cerrarModalMiniatura && _ctx.cerrarModalMiniatura(...args)))
                                                    })
                                                ]),
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createCommentVNode(" Contenedor que manejará el efecto de zoom "),
                                                    _createElementVNode("div", {
                                                        class: "zoom-area-in-modal",
                                                        ref: "imageContainerRef",
                                                        onMouseenter: _cache[2] || (_cache[2] =
                                                            //@ts-ignore
                                                            (...args) => (_ctx.handleMouseEnter && _ctx.handleMouseEnter(...args))),
                                                        onMouseleave: _cache[3] || (_cache[3] =
                                                            //@ts-ignore
                                                            (...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args))),
                                                        onMousemove: _cache[4] || (_cache[4] =
                                                            //@ts-ignore
                                                            (...args) => (_ctx.handleMouseMove && _ctx.handleMouseMove(...args)))
                                                    }, [
                                                        _createElementVNode("img", {
                                                            src: _ctx.modalImageMiniatura,
                                                            class: "modal-image",
                                                            style: _normalizeStyle(_ctx.imageZoomStyle)
                                                        }, null, 12 /* STYLE, PROPS */, _hoisted_18)
                                                    ], 544 /* NEED_HYDRATION, NEED_PATCH */)
                                                ])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createCommentVNode(" Fondo oscuro del modal (sin cambios) "),
                                (_ctx.isModalMiniaturaOpen)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 2,
                                        class: "modal-backdrop fade show",
                                        onClick: _cache[5] || (_cache[5] =
                                            //@ts-ignore
                                            (...args) => (_ctx.cerrarModalMiniatura && _ctx.cerrarModalMiniatura(...args)))
                                    }))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _createCommentVNode(" Información del Producto "),
                            _createElementVNode("div", _hoisted_19, [
                                (_ctx.product?.repuesto?.nombre)
                                    ? (_openBlock(), _createElementBlock("h1", _hoisted_20, _toDisplayString(_ctx.toTitleCase(_ctx.product.repuesto.nombre)), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("h3", {
                                    class: _normalizeClass(["text-primary mb-3", { blurredFull: !_ctx.isLoggedIn }])
                                }, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.formatCurrency(_ctx.product.precioVenta)), 1 /* TEXT */)
                                ], 2 /* CLASS */),
                                _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("p", _hoisted_22, [
                                        _hoisted_23,
                                        _createTextVNode(" " + _toDisplayString(_ctx.product.detalles), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("p", _hoisted_24, [
                                        _hoisted_25,
                                        _createTextVNode(" " + _toDisplayString(_ctx.product.modeloProveedor), 1 /* TEXT */)
                                    ])
                                ]),
                                _createCommentVNode(" Desplegables "),
                                (_ctx.product.desplegables && _ctx.product.desplegables.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                        _hoisted_27,
                                        _createElementVNode("ul", _hoisted_28, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.desplegables, (desplegable, index) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    key: index,
                                                    class: "mb-2"
                                                }, [
                                                    _createElementVNode("strong", null, _toDisplayString(desplegable.atributo.nombreAtributo) + ":", 1 /* TEXT */),
                                                    _createCommentVNode(" Caso RANGO "),
                                                    (desplegable.atributo.tipoAtributo === 'rango')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.formatNumber(desplegable.valorMin, desplegable.atributo.unidad?.decimales)) + " a " + _toDisplayString(_ctx.formatNumber(desplegable.valorMax, desplegable.atributo.unidad?.decimales)) + " " + _toDisplayString(desplegable.atributo.unidad?.simbolo), 1 /* TEXT */))
                                                        : (desplegable.atributo.tipoAtributo === 'numerico')
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _createCommentVNode(" Caso NUMÉRICO "),
                                                                _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(desplegable.valorLibre, desplegable.atributo.unidad?.decimales)) + " " + _toDisplayString(desplegable.atributo.unidad?.simbolo), 1 /* TEXT */)
                                                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                                            : (desplegable.atributo.tipoAtributo === 'booleano')
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                    _createCommentVNode(" Caso BOOLEANO "),
                                                                    _createElementVNode("span", null, _toDisplayString(desplegable.valorLibre === 'true' ? 'Sí' : 'No'), 1 /* TEXT */)
                                                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                                                : (desplegable.valor && desplegable.valor.valor !== 'NA')
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                        _createCommentVNode(" Valor por defecto (Desplegable tradicional o Texto Libre) "),
                                                                        _createElementVNode("span", null, _toDisplayString(_ctx.toTitleCase(desplegable.valor.valor)), 1 /* TEXT */)
                                                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                                                    : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(desplegable.ref || "Sin especificar"), 1 /* TEXT */))
                                                ]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("div", _hoisted_31, [
                                    _createCommentVNode(" Botón de decremento con diseño azul "),
                                    _createElementVNode("button", {
                                        class: "btn btn-primary px-2 py-1",
                                        onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.decrementQuantity()))
                                    }, _hoisted_33),
                                    _createCommentVNode(" Input de cantidad centrado y con bordes redondeados "),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control text-center mx-2",
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.item.cantidad) = $event)),
                                        style: { "width": "60px", "border-radius": "0.25rem" }
                                    }, null, 512 /* NEED_PATCH */), [
                                        [
                                            _vModelText,
                                            _ctx.item.cantidad,
                                            void 0,
                                            { number: true }
                                        ]
                                    ]),
                                    _createCommentVNode(" Botón de incremento con diseño azul "),
                                    _createElementVNode("button", {
                                        class: "btn btn-primary px-2 py-1",
                                        onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.incrementQuantity()))
                                    }, _hoisted_35)
                                ]),
                                _createCommentVNode(" Botón de Agregar al Carrito "),
                                _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("button", {
                                        class: "btn text-white",
                                        onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.agregarAlCarrito(_ctx.product.id))),
                                        disabled: _ctx.loading || _ctx.isProcessing,
                                        style: { "background-color": "#007bff" }
                                    }, [
                                        (_ctx.isProcessing)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_38))
                                            : (_openBlock(), _createElementBlock("i", _hoisted_39)),
                                        _createTextVNode(" Agregar al carrito ")
                                    ], 8 /* PROPS */, _hoisted_37)
                                ]),
                                _createCommentVNode(" Mensaje de Error o Éxito "),
                                (_ctx.productAdded)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_40, " Producto agregado al carrito con éxito. "))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("span", null, [
                                        _createTextVNode("Publicacion"),
                                        _createElementVNode("strong", null, " #" + _toDisplayString(_ctx.product.id), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("button", {
                                        class: "btn btn-link text-danger p-0 m-0",
                                        style: { "font-size": "0.8rem" },
                                        onClick: _cache[10] || (_cache[10] = () => { })
                                    }, [
                                        _hoisted_42,
                                        _createTextVNode("Reportar ")
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                (_ctx.loadingSimilar)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_46))
                    : (_ctx.similarProducts && _ctx.similarProducts.length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createCommentVNode(" Sección de Productos Similares "),
                            _createElementVNode("div", _hoisted_47, [
                                _hoisted_48,
                                _createElementVNode("div", _hoisted_49, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.similarProducts, (producto) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: "col custom-col",
                                            key: producto.id
                                        }, [
                                            _createCommentVNode(" Start Single Product "),
                                            _createElementVNode("div", {
                                                class: "single-product",
                                                onClick: ($event) => (_ctx.verDetallesProducto(producto.id))
                                            }, [
                                                _createElementVNode("div", _hoisted_51, [
                                                    _createCommentVNode(" Controles del carrito "),
                                                    _createElementVNode("div", {
                                                        class: "cart-controls",
                                                        onClick: _cache[11] || (_cache[11] = _withModifiers(() => { }, ["stop"]))
                                                    }, [
                                                        (_ctx.isProductInCart(producto.id))
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createCommentVNode(" <div class=\"quantity-controls\">\n                          <button @click.stop=\"decrementQuantity(getCartItemId(producto.id))\" :disabled=\"isProcessing\"\n                            class=\"quantity-btn\">\n                            <i class=\"lni lni-minus\"></i>\n                          </button>\n                          <span class=\"quantity\">{{ getCartQuantity(producto.id) }}</span>\n                          <button @click.stop=\"incrementQuantity(getCartItemId(producto.id))\" :disabled=\"isProcessing\"\n                            class=\"quantity-btn\">\n                            <i class=\"lni lni-plus\"></i>\n                          </button>\n                        </div> "),
                                                                (_ctx.isProductInCart(producto.id))
                                                                    ? (_openBlock(), _createElementBlock("button", _hoisted_52, _hoisted_54))
                                                                    : _createCommentVNode("v-if", true)
                                                            ], 64 /* STABLE_FRAGMENT */))
                                                            : (_openBlock(), _createElementBlock("button", {
                                                                key: 1,
                                                                onClick: _withModifiers(($event) => (_ctx.agregarAlCarrito(producto.id)), ["stop"]),
                                                                class: "cart-button",
                                                                disabled: _ctx.isProcessing || !_ctx.isLoggedIn
                                                            }, _hoisted_57, 8 /* PROPS */, _hoisted_55))
                                                    ]),
                                                    _createCommentVNode(" Mostrar la imagen de portada o una imagen por defecto "),
                                                    _createElementVNode("img", {
                                                        src: _ctx.getImagenPortada(producto.imagenes),
                                                        alt: "#",
                                                        class: "product-image-size"
                                                    }, null, 8 /* PROPS */, _hoisted_58),
                                                    _createCommentVNode(" Overlay de Confirmación "),
                                                    (_ctx.animationProductId === producto.id)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, _hoisted_61))
                                                        : _createCommentVNode("v-if", true),
                                                    _createCommentVNode(" Botón Agregar al Carrito "),
                                                    _createElementVNode("div", _hoisted_62, [
                                                        (_ctx.animationProductId !== producto.id)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                                                _createCommentVNode(" <button\n                        @click=\"agregarAlCarrito(producto.id)\"\n                        class=\"btn\"\n                        :disabled=\"isProcessing\"\n                      >\n                        <i class=\"lni lni-cart\"></i> Agregar\n                      </button> "),
                                                                _createCommentVNode(" <button @click=\"verDetallesProducto(producto.id)\" class=\"btn btn-outline-primary w-100\">\n                        <i class=\"lni lni-angle-double-right\"></i> Ver\n                      </button> ")
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_64, [
                                                    _createCommentVNode(" <span class=\"category\">{{ toTitleCase(producto.repuesto.nombre) }}</span> "),
                                                    _createElementVNode("h4", _hoisted_65, [
                                                        _createElementVNode("a", {
                                                            onClick: ($event) => (_ctx.verDetallesProducto(producto.id))
                                                        }, _toDisplayString(_ctx.toTitleCase(producto.repuesto.nombre)), 9 /* TEXT, PROPS */, _hoisted_66)
                                                    ]),
                                                    _hoisted_67,
                                                    _createElementVNode("div", {
                                                        class: _normalizeClass(["price", { blurred: !_ctx.isLoggedIn }])
                                                    }, [
                                                        _createElementVNode("span", null, _toDisplayString(_ctx.formatCurrency(producto.precioVenta)), 1 /* TEXT */)
                                                    ], 2 /* CLASS */)
                                                ])
                                            ], 8 /* PROPS */, _hoisted_50),
                                            _createCommentVNode(" End Single Product ")
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ])
                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        : (_openBlock(), _createElementBlock("div", _hoisted_68, _hoisted_71)),
                _createCommentVNode(" Animación de Carrito "),
                (_ctx.showCartAnimation)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 4,
                        class: "cart-animation",
                        style: _normalizeStyle({ left: _ctx.cartPosition.x + 'px', top: _ctx.cartPosition.y + 'px' })
                    }, _hoisted_73, 4 /* STYLE */))
                    : _createCommentVNode("v-if", true)
            ])
        ])
    ], 64 /* STABLE_FRAGMENT */));
}
